module.exports = __webpack_public_path__ + "static/media/11_ Youth_Harriet Li (Service)-min.21936f13.jpg";